import { useWorkoutClock } from '../hooks/useWorkoutClock';
import { formatSecs } from '../hooks/useRestTimer';

/**
 * How long the current workout has been running.
 *
 * Rendered both in the site header and in the workout pages' own header rows —
 * those pages deliberately have no site nav, and they are precisely where the
 * clock matters, so it has to appear in both places.
 *
 * Shows nothing at all until a workout has been started.
 */
export default function WorkoutClock() {
  const { record, seconds } = useWorkoutClock();
  if (!record) return null;

  const ended = record.endedAt != null;
  return (
    <span
      className={`nav-clock${ended ? ' nav-clock--ended' : ''}`}
      title={ended ? 'Last workout duration' : 'Workout in progress'}
    >
      <span className="nav-clock-dot" aria-hidden="true" />
      {formatSecs(seconds)}
    </span>
  );
}
